import React, { useState } from 'react';
import Axios from 'axios';

function EmailMobileModal({ show, onClose, onSuccess }) {
    const [email, setEmail] = useState('');
    const [mobile, setMobile] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState('');

    const validateEmail = (email) => {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(email);
    };

    const validateMobile = (mobile) => {
        const re = /^[0-9]{10,15}$/;
        return re.test(mobile);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        // Validation
        if (!email || !mobile) {
            setError('Please fill in all fields');
            return;
        }

        if (!validateEmail(email)) {
            setError('Please enter a valid email address');
            return;
        }

        if (!validateMobile(mobile)) {
            setError('Please enter a valid mobile number (10-15 digits)');
            return;
        }

        setSubmitting(true);

        try {
            const response = await Axios.post(
                'api/Login/SetUserData',
                {
                    email: email,
                    mobile: mobile,
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            );

            if (response.data !== 'True') {
                setError('Please enter correct email and mobile number');
                setSubmitting(false);
            } else {
                if (onSuccess) {
                    onSuccess();
                }
                // Reload page to refresh data
                window.location.reload();
            }
        } catch (error) {
            console.error(error);
            setError('An error occurred. Please try again.');
            setSubmitting(false);
        }
    };

    if (!show) return null;

    return (
        <div>
            {/* Modal Backdrop */}
            <div 
                className="modal-backdrop fade show" 
                style={{ display: 'block' }}
                onClick={onClose}
            ></div>

            {/* Modal */}
            <div 
                className="modal fade show" 
                style={{ display: 'block' }} 
                tabIndex="-1" 
                role="dialog"
                aria-labelledby="emailMobileModalLabel"
                onClick={onClose}
            >
                <div className="modal-dialog modal-dialog-centered" role="document" onClick={(e) => e.stopPropagation()}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="emailMobileModalLabel">
                                <i className="fa fa-info-circle mr-2"></i>
                                Contact Information Required
                            </h5>
                            <button type="button" className="close " aria-label="Close" onClick={onClose}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="alert alert-info">
                                <i className="fa fa-exclamation-circle mr-2"></i>
                                Please provide your email and mobile number to continue using the portal.
                            </div>

                            {error && (
                                <div className="alert alert-danger">
                                    <i className="fa fa-times-circle mr-2"></i>
                                    {error}
                                </div>
                            )}

                            <form onSubmit={handleSubmit}>
                                <div className="form-group">
                                    <label htmlFor="email">
                                        <i className="fa fa-envelope mr-2"></i>
                                        Email Address *
                                    </label>
                                    <input
                                        type="email"
                                        className="form-control form-control-lg"
                                        id="email"
                                        placeholder="your.email@example.com"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        disabled={submitting}
                                        required
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="mobile">
                                        <i className="fa fa-mobile mr-2"></i>
                                        Mobile Number *
                                    </label>
                                    <input
                                        type="tel"
                                        className="form-control form-control-lg"
                                        id="mobile"
                                        placeholder="01XXXXXXXXX"
                                        value={mobile}
                                        onChange={(e) => setMobile(e.target.value)}
                                        disabled={submitting}
                                        required
                                    />
                                    <small className="form-text text-muted">
                                        Enter 10-15 digits without spaces or special characters
                                    </small>
                                </div>

                                <div className="form-group mb-0">
                                    <button
                                        type="submit"
                                        className="btn btn-primary btn-lg btn-block"
                                        disabled={submitting || !email || !mobile}
                                    >
                                        {submitting ? (
                                            <span>
                                                <i className="fa fa-spinner fa-spin mr-2"></i>
                                                Submitting...
                                            </span>
                                        ) : (
                                            <span>
                                                <i className="fa fa-check mr-2"></i>
                                                Submit
                                            </span>
                                        )}
                                    </button>
                                </div>
                            </form>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
    );
}

export default EmailMobileModal;



// WEBPACK FOOTER //
// ./src/components/EmailMobileModal.js